module.exports = __webpack_public_path__ + "img/log_activity.77df0eb2.svg";